import { render, staticRenderFns } from "./ListInvoices.vue?vue&type=template&id=7c262166&scoped=true"
import script from "./ListInvoices.vue?vue&type=script&lang=js"
export * from "./ListInvoices.vue?vue&type=script&lang=js"
import style0 from "./ListInvoices.vue?vue&type=style&index=0&id=7c262166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c262166",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QTd,QBtn,QTooltip,QFile,QTh,QToolbar,QSpace,QPagination});
